
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

//require('./bootstrap');

window.Vue = require('vue');
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.

 */

import Vue from "vue"
import EventBus from './event-bus.js'
import Calendar from './components/Calendar/Calendar.vue'
import Gallery from './components/Products/Gallery.vue'
import Options from './components/Calendar/Options.vue'
import locale from 'element-ui/lib/locale/lang/en'
import { Affix } from 'vue-affix';


import Element from 'element-ui'


Vue.use(Element, { size: 'large', locale});
Vue.use(Affix);

window.EventBus = EventBus

const app = new Vue({
    el: '#app',
    components: {
  		'calendar-form': Calendar,
  		'options': Options,
      'affix':   Affix,
      'gallery': Gallery,
  	},
  	data() {
        return {
        	window: {
                width: 0,
                height: 0
            },
        }
    },
    computed: {
        enableAffix(){
        	if(this.window.width > 768)
        		return true;
        	return false;
        },
    },
  	methods:{
  		handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
  	},
  	created() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    },
});
